import { useCallback } from "react";

import {
  setApplication,
  setVerificationStatus,
  useGenerateGenerationJWTMutation,
  useCreateGenerationSessionMutation,
  useLazyClearSessionQuery,
} from "../../store";
import { userAccounts } from "../constants";
import { useGenerationForm } from "./";

import { generateInitialUserApplicationData } from "../../../../MPP-Common-SPA/utils/generator";

export const useGenerationFormReset = () => {
  const { form, dispatch, setDisableGeneration } = useGenerationForm();
  const [clearSession] = useLazyClearSessionQuery();
  const [generateGenerationJWT] = useGenerateGenerationJWTMutation();
  const [createGenerationSession] = useCreateGenerationSessionMutation();

  const handleReset = useCallback(async () => {
    try {
      // Clear the session first
      await clearSession().unwrap();

      const resetApplication = generateInitialUserApplicationData();
      dispatch(setApplication(resetApplication));

      // Set verification status to -1 to clear status.
      dispatch(setVerificationStatus(-1));

      // Manually reinitialize session
      const generationDetails = userAccounts[1];
      if (generationDetails) {
        try {
          const jwtResult = await generateGenerationJWT(
            generationDetails
          ).unwrap();
          await createGenerationSession(jwtResult).unwrap();
          console.log("Session reinitialized successfully");
        } catch (error) {
          console.error("Session reinitialization failed:", error);
        }
      }

      form.resetForm();
      setTimeout(() => form.validateForm());
      window.scrollTo({ top: 0, behavior: "smooth" });
      setDisableGeneration(false);
    } catch (error) {
      console.error("Reset error:", error);
    }
  }, [
    clearSession,
    dispatch,
    form,
    generateGenerationJWT,
    createGenerationSession,
    setDisableGeneration,
  ]);

  return { handleReset };
};
